export default __webpack_public_path__ + "static/media/FlyingFrog12.e667afc9.png";